import {Button, Form, Input, AutoComplete, Space, Popconfirm, Table, Select} from 'antd'
import React, {useContext, useEffect, useImperativeHandle, useRef, useState} from 'react'
import {
  DeleteOutlined,
  SearchOutlined,
  EditOutlined,
  VerticalAlignTopOutlined,
  VerticalAlignBottomOutlined,
  PlusCircleOutlined
} from '@ant-design/icons'
import {getObjChildPath, removeDuplicate, fetchSourceType} from '../../../utils'
import FieldSetModal from './FieldSetModal'
import {withTranslation, useTranslation} from 'react-i18next'

const EditableContext = React.createContext(null)

const EditableRow = ({index, ...props}) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  )
}

const EditableCell = ({value, dataBody, title, editable, children, dataIndex, record, handleSave, dataAutoCompleteSource, ...restProps}) => {
  const {t} = useTranslation()
  const inputRef = useRef(null)
  const form = useContext(EditableContext)

  // const [result, setResult] = useState([]);
  //
  // useEffect(() => {
  //   if(dataAutoCompleteSource) {
  //     setResult(dataAutoCompleteSource)
  //   }
  // }, ['dataAutoCompleteSource']);


  const sourceList = [
    {key: 'Result', value: 'Result'},
    {key: 'Parameter', value: 'Parameter'},
    {key: 'FixedValue', value: 'FixedValue'}
  ]

  const save = async () => {
    try {
      const values = await form.validateFields()
      // toggleEdit();
      handleSave({...record, ...values})
    } catch (errInfo) {
      console.log('Save failed:', errInfo)
    }
  }

  let childNode = children

  if (editable) {
    if (dataIndex === 'name') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.name ? record.name : ''}>
          <Input ref={inputRef} onPressEnter={save} onBlur={save}/>
        </Form.Item>
      )
    } else if (dataIndex === 'source') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.source ? record.source : ''}>
          <Select
            placeholder={t(`apiManagement.SelectSource`)}
            onChange={save}
          >
            {sourceList.length > 0 ? sourceList.map(item => <Select.Option key={item.key} value={item.value}>{item.value}</Select.Option>) : null}
          </Select>
        </Form.Item>
      )
    } else if (dataIndex === 'path') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.path ? record.path : ''}>
          <AutoComplete
            options={dataAutoCompleteSource}
            placeholder={t(`general.pleaseSelect`)}
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
            }
            onChange={save}
          />
        </Form.Item>
      )
    } else if (dataIndex === 'retainKey') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.retainKey}>
          <Select
            placeholder={t(`apiManagement.selectRetainKey`)}
            onChange={save}
          >
            <Select.Option key={true} value={true}>true</Select.Option>
            <Select.Option key={false} value={false}>false</Select.Option>
          </Select>
        </Form.Item>
      )

    }
  }

  return <td {...restProps}>{childNode}</td>
}

const TargetDataForm = (props) => {
  const [dataSource, setDataSource] = useState([])
  const [dataAutoCompleteSource, setDataAutoCompleteSource] = useState([])
  const [fileSetVisible, setFileSetVisible] = useState(0)
  const [count, setCount] = useState(0)
  const {dataBody, value, onChange, dataPaths, onRef,t} = props
  const [searchVal, setSearchVal] = useState('')
  const fieldSetModalRef = useRef()
  const [isRetainKeyShow, setIsRetainKeyShow] = useState(false)
  useImperativeHandle(onRef, () => ({
    init,
  }))

  useEffect(() => {
    if (value.length) {
      setDataSource(addRowKey(value))
    }

    if (value.length === 1 && value[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    }

  }, ['value'])
  const addRowKey = (list) => {
    if (!list) {
      return null
    }
    const newList = []
    list.forEach((item, i) => {
      const index = `${i + 1}`
      const newItem = {
        ...item,
        index: index
      }
      newList.push(newItem)
    })
    return newList
  }
  const init = () => {
    if (dataBody) {
      setDataAutoCompleteSource(fetchTestResultList)
    }
    if (dataSource.length < 1) {
      handleProcess()
    }
    if (value.length) {
      let source = value.map((item, index) => {
        item.source = fetchSourceType(item.path)
        return item
      })
      setDataSource(addRowKey(source))
    }
  }
  const onSearchChange = (e) => {
    setSearchVal(e.target.value)
  }
  const customRow = (record) => {
    return searchVal && !record.name.toUpperCase().includes(searchVal.toUpperCase()) ? {
      style: {
        'display': 'none'
      }
    } : {}
  }

  // 清空 dataSource 全部数据
  const clearAll = (key) => {
    setDataSource([])
    onChange([])
    // this.change()
  }
  // 点击 Process 获取事件
  const handleProcess = (key) => {
    const testResultList = fetchTestResultList()
    setDataSource(addRowKey(testResultList))
    onChange(testResultList)

    if (testResultList.length === 1 && testResultList[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    } else {
      setIsRetainKeyShow(false)
    }
  }

  const handleDelete = (index) => {
    dataSource.splice(index, 1)
    setDataSource(dataSource)
    onChange(dataSource)

    if (dataSource.length === 1 && dataSource[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    } else {
      setIsRetainKeyShow(false)
    }
  }

  // 移动数据到最顶
  const moveTop = (record, index) => {
    dataSource.splice(index, 1)
    dataSource.unshift(record)
    setDataSource(dataSource)
    onChange(dataSource)
  }
  // 移动数据到最底部
  const moveBottom = (record, index) => {
    dataSource.splice(index, 1)
    dataSource.push(record)
    setDataSource(dataSource)
    onChange(dataSource)
    // this.dataSource.splice(index, 1)
    // this.dataSource.push(record)
    // this.change()
  }

  // 增加一行数扭
  const insertRow = (value, record) => {
    let max = 0
    dataSource.forEach(item => {
      if (item.key > max) {
        max = item.key
      }
    })
    const newObj = {
      key: max + 1,
      index: dataSource.length + 1,
      name: '',
      path: '',
      children: null
    }
    const curIndex = dataSource.findIndex(item => item.index === record.index)
    dataSource.splice(curIndex + 1, 0, newObj)
    setDataSource(addRowKey(dataSource))
    onChange(dataSource)
    //this.change()

    if (dataSource.length === 1 && dataSource[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    } else {
      setIsRetainKeyShow(false)
    }
  }

  // 拉取之前 JSON 数据保存到 testResultList
  const fetchTestResultList = () => {
    try {
      const resultJson = JSON.parse(dataBody || '{}')
      let testResultList = []
      dataPaths.forEach(path => {
        if (typeof path === 'string') {
          let childs = getObjChildPath(resultJson, path).map(child => {
            return {
              source: fetchSourceType(child.value),
              ...child
            }
          })
          testResultList.push(...childs)
        }
        if (typeof path === 'object') {
          let childs = getObjChildPath(resultJson, path.dataPath).map(child => {
            return {
              source: fetchSourceType(child.value),
              ...child
            }
          })
          testResultList.push(...childs)
        }
      })
      testResultList = removeDuplicate(testResultList)
      return testResultList
    } catch (e) { }
  }

  const defaultColumns = [
    {
      title: t(`apiManagement.no`),
      dataIndex: 'index',
      render: (text, record, index) => `${index + 1}`,
      isShow: true
    },
    {
      title: t(`apiManagement.name`),
      dataIndex: 'name',
      width: '20%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.source`),
      dataIndex: 'source',
      width: '20%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.path`),
      dataIndex: 'path',
      width: '20%',
      editable: true,
      isShow: true
    },
    {
      title: t(`apiManagement.retainKey`),
      dataIndex: 'retainKey',
      width: '20%',
      editable: true,
      isShow: isRetainKeyShow
    },
    {
      title: t(`general.action`),
      dataIndex: 'action',
      align: 'center',
      isShow: true,
      render: (_, record, index) =>
        dataSource.length >= 1 ? (
          <>
            <a style={{marginRight: 16}} onClick={() => editField(record, index)}><EditOutlined/></a>
            <a style={{marginRight: 16}} onClick={() => moveTop(record, index)}><VerticalAlignTopOutlined/></a>
            <a style={{marginRight: 16}} onClick={() => moveBottom(record, index)}><VerticalAlignBottomOutlined/></a>
            <a style={{marginRight: 16}} onClick={() => insertRow(_, record)}><PlusCircleOutlined/></a>
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(index)}>
              <a><DeleteOutlined/></a>
            </Popconfirm>
          </>
        ) : null,
    },
  ]

  const handleAdd = () => {
    const newData = {
      key: dataSource.length,
      index: dataSource.length + 1,
      name: '',
      source: 'Result',
      path: '',
      children: null
    }
    let data = dataSource
    data.push(newData)
    setDataSource(addRowKey(data))
    // setDataSource([...dataSource, newData]);
    // setCount(count + 1);
    onChange([...dataSource, newData])
    setCount(dataSource.length + 1)

    if (dataSource.length === 1 && dataSource[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    } else {
      setIsRetainKeyShow(false)
    }
  }

  const handleSave = (row) => {
    const newData = [...dataSource]
    const index = newData.findIndex((item) => row.index === item.index)
    const item = newData[index]
    newData.splice(index, 1, {...item, ...row})
    onChange(newData)
    setDataSource(newData)
  }
  const handleCancel = () => {
    setFileSetVisible(false)
  }

  const editField = (record, index) => {
    setFileSetVisible(true)
    setTimeout(() => {
      fieldSetModalRef.current.init(record)
    })
  }

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  }

  const column = defaultColumns.map((col) => {
    if (!col.editable) {
      return col
    }

    return {
      ...col,
      onCell: (record) => ({
        dataBody,
        dataAutoCompleteSource,
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })

  for (var i = 0; i < column.length; i++) {
    if (column[i].isShow === false) {
      column.splice(i, 1)
    }
  }

  const columns = column

  const onFieldSetChange = (row) => {
    dataSource.forEach(function (item, index) {
      if (item.index === row.index) {
        dataSource.splice(index, 1, {...item, ...row})
      }
    })
    setDataSource([...dataSource])
    onChange(dataSource)

    if (dataSource.length === 1 && dataSource[0].fieldType === 'ARRAY') {
      setIsRetainKeyShow(true)
    } else {
      setIsRetainKeyShow(false)
    }
  }
  const rowKey = (item) => {
    return item.path ? item.path : item.index
  }
  return (
    <div>
      <Input placeholder={t(`apiManagement.searchName`)} suffix={<SearchOutlined/>} style={{width: 200, marginRight: 16,}} onChange={onSearchChange}/>
      <Button onClick={handleAdd} type="primary" style={{marginBottom: 16, marginRight: 16,}}>{t(`general.add`)}</Button>
      <Button onClick={handleProcess} style={{marginBottom: 16, marginRight: 16,}}>{t(`general.process`)}</Button>
      <Button onClick={clearAll} style={{marginBottom: 16, marginRight: 16,}}>{t(`general.clear`)}</Button>
      <Table
        components={components}
        dataSource={[...dataSource]}
        columns={columns}
        childrenColumnName="childrens"
        pagination={false}
        onRow={customRow}
        rowKey={rowKey}
      />
      {fileSetVisible ? <FieldSetModal
        fileSetVisible={fileSetVisible}
        handleCancel={handleCancel}
        onRef={fieldSetModalRef}
        onChange={onFieldSetChange}
      /> : null}
    </div>
  )
}

export default withTranslation()(TargetDataForm)
